'use client';
import React from 'react';
import style from './MainFooterInfo.module.scss';
import { Icons } from '@/components/icons';
import { Button } from '@/components/ui/button';
import { useModalContext } from '@/context/ModalsContext';

export const MainFooterInfo = () => {
  const { setisModalCallsOpen } = useModalContext();
  return (
    <div className={style.container}>
      <div>
        <Icons.logoWhite />
        <p className="mt-8 text-left text-white">Home Solutions with Tytum</p>
      </div>
      <div className="mt-10 text-left">
        <p className="mb-5 text-left text-white">Need Urgent Service?</p>
        <Button
          onClick={() => setisModalCallsOpen(true)}
          className=" bg-textOrange flex gap-2 rounded-full px-5 py-2 text-base text-white hover:opacity-75"
        >
          <Icons.phoneIcon /> <p>Call Us</p>
        </Button>
      </div>
    </div>
  );
};
